export default __webpack_public_path__ + "static/media/Strangler's Gloves of Creeping Death.24d976d4.jpg";